import {
  Component,
  OnInit,
  LOCALE_ID,
  Inject,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from "@angular/core";
import { CalendarComponent } from "ionic2-calendar";
import {
  AlertController,
  IonDatetime,
  ModalController,
  NavController,
  NavParams,
} from "@ionic/angular";
import { formatDate } from "@angular/common";
import { EventoService } from "../../services/evento.service";
import { AuthService } from "src/app/services/auth.service";
import {
  NavigationStart,
  Router,
  NavigationEnd,
  NavigationError,
  Event,
} from "@angular/router";
import { SearchService } from "src/app/services/search.service";
import { CreateActionsModalComponent } from "./create-actions-modal/create-actions-modal.component";
import { Subscription } from "rxjs";
import { LoadingService } from "src/app/services/loading.service";
import { CursosService } from "src/app/services/cursos.service";
import { TranslationLoadedService } from "src/app/services/translation-loaded.service";
import { date } from "src/app/institute/interfaces/data";

@Component({
  selector: "app-create-actions-calendar",
  templateUrl: "./create-actions-calendar.component.html",
  styleUrls: ["./create-actions-calendar.component.scss"],
})
export class CreateActionsCalendarComponent implements OnInit {
  private id: number;
  private auth_key: string;
  displayUserData: any;
  textSearch: string;
  searchPersonsResult = [];
  dataLoaded = false;
  loadBtnSave = true;

  avatar = "assets/imagenes/sistema/user1.png";
  public calendarComponent: any;

  eventSource = [];
  viewTitle: string;
  limite = 1;
  selectedDate: Date;
  startTime: string;
  endTime: string;
  showStartTimePicker = false;
  showEndTimePicker = false;
  current: Date = new Date();
  showCalendar = true;
  shwowEvent = false;
  asingTutor = false;
  calendar = {
    mode: "month",
    currentDate: new Date(),
  };

  @ViewChild(CalendarComponent) isCal: CalendarComponent;
  @ViewChild("inputEndTime") inputEndTime: IonDatetime;
  @ViewChild("inputStartTime") inputStartTime: IonDatetime;

  event = {
    title: "",
    desc: "",
    startTime: null,
    endTime: null,
    allDay: false,
    tutor: "",
  };

  respEvents = [
    {
      title: "",
      desc: "",
      startTime: null,
      endTime: null,
      allDay: false,
    },
  ];

  private timeRangeSubscription: Subscription;

  constructor(
    private alertCtrl: AlertController,
    private eventService: EventoService,
    private authService: AuthService,
    private searchService: SearchService,
    public navCtrl: NavController,
    private modalCtrl: ModalController,
    private changeDetector: ChangeDetectorRef,
    @Inject(LOCALE_ID) private locale: string,
    private router: Router,
    private loadingServices: LoadingService,
    private cursosService: CursosService,
    private _translationLoadedService: TranslationLoadedService
  ) {
    this._translationLoadedService.startLoading();
    this._translationLoadedService.isLoading$.subscribe((isLoading) => {
      this.dataLoaded = isLoading;
      if (!this.dataLoaded) {
        setTimeout(() => {
          this._translationLoadedService.finishLoading();
        }, 1100);
      }
    });
    setInterval(() => {
      this.authService.userData$.subscribe((res: any) => {
        if (!this.displayUserData) {
          this.displayUserData = res;
          this.loadVariables();
        }
      });
    }, 2500);
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        console.log("event: ", event);
      }
      if (event instanceof NavigationEnd) {
        this.loadVariables();
      }
      if (event instanceof NavigationError) {
        // Hide loading indicator
        // Present error to user
        console.log(event.error);
      }
    });
  }

  ngOnInit() {
    this.alertCtrl.getTop();
  }

  loadVariables() {
    this.id = this.displayUserData?.id;
    this.auth_key = this.displayUserData?.auth_key;
    this.loadActv();
    this.getMyActivities();
  }

  saveEvent() {
    if (this.event.allDay) {
      this.event.startTime.setHours("00");
      this.event.startTime.setMinutes("00");
      this.event.endTime.setHours("23");
      this.event.endTime.setMinutes("59");
    }
    this.loadBtnSave = false;
    this.createEvent();
  }

  loadActv() {
    if (this.id && this.auth_key)
      this.cursosService
        .getCaledarEvents(this.id, this.auth_key)
        .subscribe((res) => {
          this.eventSource = [];
          for (let detalle of res) {
            this.eventSource.push({
              title: detalle.titulo,
              desc: detalle.descripcion,
              startTime: new Date(
                detalle.fecha_inicio
                  ? detalle.fecha_inicio
                  : detalle.hora_inicio
              ),
              endTime: new Date(
                detalle.fecha_fin ? detalle.fecha_fin : detalle.hora_fin
              ),
              allDay: false,
              type: detalle.tipo,
              id_curso: detalle.id_curso,
              id_evento : detalle.id
            });
          }
          this.isCal.loadEvents();
        });
  }

  getMyActivities() {
    this.respEvents = null;
    this.eventService
      .getMyActivities(this.id, this.auth_key)
      .subscribe((resp) => {
        if (resp.length > 0) {
          resp.map(function (item) {
            item.title = item.titulo;
            item.desc = item.descripcion;
            item.startTime = new Date(item.hora_inicio);
            item.endTime = new Date(item.hora_fin);
            item.allDay = item.allDay = "0" ? false : true;
          });
          this.eventSource.push(...resp);
          this.isCal.loadEvents();
        }
      });
  }

  createEvent() {
    if (this.event.desc != "" && this.event.title != "") {
      this.eventService
        .createEvents(this.id, this.auth_key, this.event)
        .subscribe(() => {
          this.loadVariables();
          this.showCalendar = true;
          this.shwowEvent = false;
          this.initEnvent();
          this.loadBtnSave = true;
        });
    } else {
      this.presentAlert(2);
    }
  }

  // Change current month/week/day
  next() {
    this.isCal.slideNext();
  }

  back() {
    this.isCal.slidePrev();
  }

  // Selected date reange and hence title changed
  onViewTitleChanged(title) {
    this.viewTitle = title;
  }

  onTimeSelected(event) {
    this.event.startTime = new Date(event.selectedTime);
    this.event.endTime = new Date(event.selectedTime);

    this.startTime = this.converDateIso(this.event.startTime); // Hora de inicio en formato ISO
    this.endTime = this.converDateIso(this.event.endTime); // Hora de fin en formato ISO
  }

  converDateIso(date) {
    let isoDate = new Date(
      date.getTime() - date.getTimezoneOffset() * 60000
    ).toISOString();
    return isoDate;
  }

  async openTimeRangeModal() {
    const modal = await this.modalCtrl.create({
      component: CreateActionsModalComponent,
      componentProps: {
        selectedStartTime: this.startTime,
        selectedEndTime: this.endTime,
      },
    });

    modal.onDidDismiss().then((dataReturned) => {
      if (dataReturned !== null) {
        this.event.startTime = new Date(dataReturned.data.startTime);
        this.event.endTime = new Date(dataReturned.data.endTime);

        this.startTime = this.converDateIso(this.event.startTime); // Hora de inicio en formato ISO
        this.endTime = this.converDateIso(this.event.endTime); // Hora de fin en formato ISO
        this.changeDetector.detectChanges();
      }
    });
    return await modal.present();
  }

  // Calendar event was clicked
  async onEventSelected(event) {
    // Use Angular date pipe for conversion
    let start = formatDate(event.startTime, "short", this.locale);
    let end = formatDate(event.endTime, "short", this.locale);
    let buttons: any = [
      {
        text: "Aceptar",
      },
    ];
    if (event.type == "Actividad") {
      buttons.unshift({
        text: "Ver Actividad",
        handler: () => {
          this.router.navigate(["/cursos/estudiante-curso/", event.id_curso]);
        },
      });
    }else{
      buttons.unshift({
        text: "Eliminar",
        handler: () => {
          this.deleteEvent(event);
        },
      });
    }
    //Crar alerta
    const alert = await this.alertCtrl.create({
      header: event.title,
      subHeader: event.desc,
      message: "Inicio: " + start + "<br><br>Fin: " + end,
      buttons: buttons,
    });
    alert.present();
  }
  deleteEvent(event: any) {
    this.eventService
      .deleteEventActivity(this.id, this.auth_key, event.id_evento)
      .subscribe((res) => {
        this.loadVariables();
      });
  }

  follow(idSigue) {
    this.loadingServices.present("Por favor esper...");
    this.searchService
      .follow(this.id, this.auth_key, idSigue)
      .subscribe((res) => {
        if (res.follow) {
          document.getElementById(`btn${idSigue}`).innerHTML =
            "Dejar de seguir";
          document.getElementById(`btn${idSigue}`).style.color =
            "#2dd36f !important";
          // this.following = true;
        }
        if (res.unfollow) {
          document.getElementById(`btn${idSigue}`).innerHTML = "Seguir";
          document.getElementById(`btn${idSigue}`).style.color =
            "#f4f5f8 !important";
          // this.following = true;
        }
        this.loadingServices.dismiss();
      });
  }

  closeCreate() {
    this.showCalendar = true;
    this.shwowEvent = false;
    this.asingTutor = false;
    this.initEnvent();
  }

  showCreate() {
    this.showCalendar = false;
    this.shwowEvent = true;
  }

  addTutor() {
    this.showCalendar = false;
    this.asingTutor = true;
    this.event.tutor = "";
  }

  initEnvent() {
    this.event = {
      title: "",
      desc: "",
      startTime: null,
      endTime: null,
      allDay: false,
      tutor: "",
    };
    // this.endTime = null;
    // this.startTime = null;
  }

  serchText() {
    this.searchService.event.emit(this.textSearch);
    if (this.textSearch != "") {
      this.navCtrl.navigateRoot("/search");
    }
  }

  searchPersons() {
    this.searchService
      .getAllResult(this.id, this.auth_key)
      .subscribe((result) => {
        this.searchPersonsResult = result.Personas.filter((persona) =>
          persona.nombre_apellido
            .toLowerCase()
            .includes(this.textSearch.toLowerCase())
        );
      });
  }

  onSearchInput() {
    this.searchPersons();
  }

  selectPerson(persona) {
    this.event.tutor = persona.nombre_apellido;
  }

  async presentAlert(op) {
    if (op == 1) {
      const alert = await this.alertCtrl.create({
        header: "Alerta",
        message: "La hora fin debe ser mayor a la de inicio",
        buttons: ["Aceptar"],
      });
      await alert.present();
      const { role } = await alert.onDidDismiss();
    }
    if (op == 2) {
      const alert = await this.alertCtrl.create({
        header: "Alerta",
        message: "Te faltan datos por llenar!",
        buttons: ["Aceptar"],
      });
      await alert.present();
      const { role } = await alert.onDidDismiss();
    }
  }
}
